<template>
  <nuxt-child />
</template>

<script>
export default {
  head() {
    return {
      title: '我的采购'
    }
  }
}
</script>
